import ErrorMassive from './ErrorMassive'
export default ErrorMassive
